
export const PAGE_CONFIG = {
  "name": "reportTabs",
  "config": {
    "tabList": [
      {
        "pageType": "datalab",
        "id": "a707640e0c5ec54ec1395862118b1338",
        "nameEn": "By Cohort Analysis",
        "nameCn": "By Cohort Analysis",
        "logConfig": {
          "pageId": "",
          "pageName": "By Cohort Analysis",
          "pagePath": "/multiReports/cbt"
        }
      },
      {
        "pageType": "datalab",
        "id": "e75d220fe895b2032dd2a51fe16cfe12",
        "nameEn": "By Class Analysis",
        "nameCn": "By Class Analysis",
        "logConfig": {
          "pageId": "",
          "pageName": "By Class Analysis",
          "pagePath": "/multiReports/cbt"
        }
      },
      {
        "pageType": "outPath",
        "id": "/dashboard/game/pc_dev_demo/funnel/registerFunnelDaily",
        "nameEn": "Progression Funnel",
        "nameCn": "关卡漏斗",
        "logConfig": {
          "pageId": "",
          "pageName": "Progression Funnel",
          "pagePath": "/multiReports/cbt"
        }
      },
      {
        "pageType": "outPath",
        "id": "/dashboard/game/pc_dev_demo/comparisonAnalysis/eventComparison",
        "nameEn": "Event Comparison",
        "nameCn": "事件对比",
        "logConfig": {
          "pageId": "",
          "pageName": "Event Comparison",
          "pagePath": "/multiReports/cbt"
        }
      },
      {
        "pageType": "pdf",
        "id": "https://databrain-test-1300342678.cos.ap-singapore.myqcloud.com/dashboard_PDF/45aa57a2-fc35-4dd2-a773-6c2e915da7b4.pdf",
        "nameEn": "PDF Test",
        "nameCn": "PDF 测试",
        "logConfig": {
          "pageId": "",
          "pageName": "PDF Test",
          "pagePath": "/multiReports/cbt"
        }
      },
      {
        "pageType": "looker",
        "id": "https://databrain.cloud.looker.com/embed/dashboards/107",
        "nameEn": "Looker Test",
        "nameCn": "looker 测试",
        "models": [
          "intelligence"
        ],
        "logConfig": {
          "pageId": "",
          "pageName": "Looker Test",
          "pagePath": "/multiReports/cbt"
        }
      },
      {
        "pageType": "tableau",
        "id": "https://sg-tableau.intlgame.com/#/site/DataBrain/views/tableauv1_1bysallyxue0730_16560647984230/table_1?:iid=4",
        "nameEn": "Tableau Test",
        "nameCn": "Tableau 测试",
        "logConfig": {
          "pageId": "",
          "pageName": "Looker Test",
          "pagePath": "/multiReports/cbt"
        }
      },
      {
        "pageType": "auth_path",
        "id": "mobile",
        "authPath": "/as/report/lojb07li/soft-launch-miniclip.html",
        "nameEn": "Auth Path",
        "nameCn": "Auth Path",
        "logConfig": {
          "pageId": "100615",
          "pageName": "Mobile Soft Launch Radar",
          "pagePath": "/game-scouting/mobile"
        }
      }
    ]
  }
};